import { render, staticRenderFns } from "./cognitivetraining.vue?vue&type=template&id=5e278216&scoped=true"
import script from "./cognitivetraining.vue?vue&type=script&lang=js"
export * from "./cognitivetraining.vue?vue&type=script&lang=js"
import style0 from "./cognitivetraining.vue?vue&type=style&index=0&id=5e278216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e278216",
  null
  
)

export default component.exports